export default __webpack_public_path__ + "static/springanimation-notext-97b94de0e4daf3f7a09581d72f2edc88.mp4";